// extracted by mini-css-extract-plugin
export default {"cardBody":"Settings_cardBody__DSRw7"};